import { Route } from '@angular/router';
import { TenderComponent, TenderTabsComponent } from '../../../layouts';
import {
    TenderAnalyticsConversionFactorResolver,
    TenderResolver,
    TenderRevisionResolver,
    TenderUnitRatesResolver
} from '../../resolvers';
import {
    analyticsSettingsRoute,
    bidImportRoute,
    tenderAwardsRoute,
    tenderContractRoute,
    tenderContractsRoute,
    tenderInvitationRoute,
    tenderReportsRoute,
    tenderSupplierInputBidRoute,
    tenderSuppliersRoute
} from './children';

import { UserSettingsResolver } from "../../../../account/routing/resolvers/user-settings.resolver";
import { AuthenticatedUserGuard } from '../../../../auth/routing/guards';

import { TenderOverviewComponent } from "../../../pages/tender-overview/tender-overview.component";
import { TenderStatusGuard } from '../../guards';
import { SealedTenderGuard } from '../../guards/sealed-tender.guard';

export const tenderRoutes: Route = {
    path: 'tenders/:id',
    component: TenderComponent,
    resolve: {
        tender: TenderResolver
    },
    canActivate: [AuthenticatedUserGuard, TenderStatusGuard],
    children: [
        {
            // Canonical Tender Overview route. The page used to live under
            // /revision; we keep that path as a redirect below for old
            // bookmarks and links.
            path: 'overview',
            component: TenderOverviewComponent,
            // Sealed tenders lock Tender Overview while any round is open, for
            // the same reason Dashboard and Vertical Analysis are locked: the
            // page renders each supplier's differential.
            canActivate: [SealedTenderGuard],
            resolve: {
                tender: TenderRevisionResolver,
                conversion_factor: TenderAnalyticsConversionFactorResolver,
                unitRates: TenderUnitRatesResolver,
                userSettings: UserSettingsResolver
            },
        },
        // Legacy deep-link redirects. Keep so existing bookmarks / emails keep working.
        { path: 'revision', redirectTo: 'overview', pathMatch: 'full' },
        { path: 'report', redirectTo: 'reports/year-over-year', pathMatch: 'full' },
        { path: 'bid-analysis-report', redirectTo: 'reports/bid-analysis', pathMatch: 'full' },
        { path: 'bid-fee-report', redirectTo: 'reports/bid-fee', pathMatch: 'full' },
        {
            path: 'restricted',
            loadComponent: () => import('../../../pages/sealed-tender-restricted/sealed-tender-restricted.component')
                .then(m => m.SealedTenderRestrictedComponent)
        },
        {
            path: '',
            component: TenderTabsComponent,
            children: [
                {
                    path: '',
                    redirectTo: 'locations',
                    // component: SealedTenderRedirectComponent,
                    pathMatch: 'full'
                },
                tenderSuppliersRoute,
                tenderInvitationRoute,
                tenderReportsRoute,
                tenderContractsRoute,
                tenderAwardsRoute,
                tenderSupplierInputBidRoute,
                analyticsSettingsRoute
            ]
        },
        bidImportRoute,
        tenderContractRoute
    ]
};
